import { getToken, getAppToken } from '@/utils/auth';
import Service from '../../env/index.js';

// 数据流下载文件
const https = ({ data = null, name = 'defult', url = '', service = 'OTMS_WEB_PLUS_SERVER', type = 'xlsx' }) => {
    const http = new XMLHttpRequest();
    http.open('POST', `${Service[service]}${url}`);
    http.responseType = 'blob';
    http.setRequestHeader('Authorization', getToken());
    const appToken = getAppToken();
    if (appToken) {
        http.setRequestHeader('Token', appToken);
    }
    http.setRequestHeader('Content-Type', 'application/json');
    http.onreadystatechange = () => {
        if (http.status === 200 && http.readyState === 4) {
            const filename = `${name}.${type}`;
            const blob = new Blob([http.response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            });
            const csvUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = csvUrl;
            link.download = filename;
            link.click();
        }
    };
    http.send(JSON.stringify(data));
};
export default https;
